import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

import PageNotFound from 'components/PageNotFound/PageNotFound';
import AutomationList from './AutomationList/AutomationList';
import WorkflowBuilder from './WorkflowBuilder/WorkflowBuilder';
import ListAutomationErrorLogWrapper from 'modules/settings/workflow_automation/components/ListAutomationErrorLog/ListAutomationErrorLog';
import AutomationStoppedInstanceList from './AutomationStoppedInstanceList/AutomationStoppedInstanceList';

const AutomationRouter = () => {
  const { path } = useRouteMatch();

  const routeConfigs = [
    {
      path: `${path}`,
      component: AutomationList,
    },
    {
      path: `${path}/edit/:automationRuleId?`,
      component: WorkflowBuilder,
    },
    {
      path: `${path}/add`,
      component: WorkflowBuilder,
    },
    {
      path: `${path}/error-logs/:automationErrorLogParentId`,
      component: ListAutomationErrorLogWrapper,
    },
    {
      path: `${path}/stopped-instances/:automationId`,
      component: AutomationStoppedInstanceList,
    },
    {
      path: '*',
      component: PageNotFound,
    },
  ];

  return (
    <Switch>
      {routeConfigs?.map((config) => (
        <Route key={config?.path} exact path={config?.path} component={config?.component} />
      ))}
    </Switch>
  );
};

export default AutomationRouter;
